import { createContext, ReactNode, useMemo, useState } from 'react';
import { NavItem } from '@components/layout/src/layout.types';
import { EventNavigationContextValue } from '@contexts/navigation/navigation.type';

export const EventNavigationContext = createContext<EventNavigationContextValue>({
  eventNavigationItems: [],
  setEventNavigation: () => {},
});

export const EventNavigationProvider = ({ children }: { children: ReactNode }) => {
  const [eventNavigationItems, setEventNavigationItems] = useState<NavItem[]>([]);

  const contextValue = useMemo(
    () => ({
      eventNavigationItems,
      setEventNavigation: setEventNavigationItems,
    }),
    [eventNavigationItems]
  );

  return <EventNavigationContext.Provider value={contextValue}>{children}</EventNavigationContext.Provider>;
};
